// Each method in this file does one thing! Push an event to dataLayer.

const push = function (payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
};

// GA4 reads ecommerce.items from the dataLayer, which persists between pushes.
// Clearing it first stops a previous event's items leaking into the next one.
const trackEcommerceEvent = function (name, ecommerce) {
    push({ecommerce: null});
    push({
        'event': name,
        ecommerce: ecommerce,
    });
};

export default class AnalyticsTracker {
    trackViewItem(item) {
        trackEcommerceEvent('view_item', {
            items: [item],
        });
    }

    trackViewItemList(listId, listName, items) {
        trackEcommerceEvent('view_item_list', {
            item_list_id: listId,
            item_list_name: listName,
            items: items,
        });
    }

    trackSelectItem(listId, listName, item) {
        trackEcommerceEvent('select_item', {
            item_list_id: listId,
            item_list_name: listName,
            items: [item],
        });
    }

    trackSearch(term, results) {
        push({
            'event': 'search',
            search_term: term,
            search_results: results,
        });
    }

    trackFilterProducts(category, values, results) {
        push({
            'event': 'filter_products',
            filter_category: category,
            filter_values: values.join(', '),
            filter_count: values.length,
            search_results: results,
        });
    }

    trackFileDownload(params) {
        push({
            'event': 'file_download',
            ...params,
        });
    }

    trackConfiguratorStart(mode) {
        push({
            'event': 'configurator_start',
            configurator_mode: mode,
        });
    }

    trackConfiguratorStep(mode, stepNumber) {
        push({
            'event': 'configurator_step',
            configurator_mode: mode,
            step_number: stepNumber,
        });
    }

    trackConfiguratorComplete(mode, params = {}) {
        push({
            'event': 'configurator_complete',
            configurator_mode: mode,
            ...params,
        });
    }

    trackGenerateLead(leadType, params = {}) {
        push({
            'event': 'generate_lead',
            lead_type: leadType,
            ...params,
        });
    }

    trackLogin(method) {
        push({
            'event': 'login',
            method: method,
        });
    }
}

export const analyticsTracker = new AnalyticsTracker();
